import React from "react";
import InputField from "../../../Components/InputField";
import { Box, Card, Typography } from "@mui/material";
import CustomTypography from "../../../Components/Typography";
import muiStyles from "../styles/muiStyles";
import MuiLink from "@mui/material/Link";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { KEILOT_WHATSAPP_NUMBER } from "../../../Constants/config";

const BusinessProfile = () => {
  const { t } = useTranslation("page-business-settings");
  const { cardStyles, inputGridStyles } = muiStyles;

  const { values } = useFormikContext();

  const {
    businessLegalName = "",
    businessLocation = "",
    businessType = "",
    businessNumber = ""
  } = values;

  // Licensed/exempt dealers have a dealer number; companies have a ח"פ.
  const businessNumberLabel = ["EXEMPT_BUSINESS", "AUTHORIZED_BUSINESS"].includes(businessType)
    ? t("business_number_dealer")
    : ["COMPANY_LTD", "CORPORATION"].includes(businessType)
      ? t("business_number_company")
      : t("business_number");

  return (
    <Card sx={cardStyles}>
      <Box
        display="flex"
        justifyContent="space-between"
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: "8px", sm: "16px" }
        }}
      >
        <CustomTypography type="subheading">
          {t("business_profile")}
        </CustomTypography>

        <Typography
          color="rgba(47, 43, 61, 0.9)"
          sx={{ fontWeight: 400, fontSize: "14px" }}
        >
          {t("for_changes")}{" "}
          <MuiLink
            href={`https://api.whatsapp.com/send/?phone=${KEILOT_WHATSAPP_NUMBER}&text=${t('help_whatsapp_message_text', {ns:"bottom-menu-and-settings"})} &app_absent=0`}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "rgba(47, 43, 61, 0.9)",
              textDecorationColor: "rgba(47, 43, 61, 0.9)"
            }}
          >
            {t("contact_commy")}
          </MuiLink>
        </Typography>
      </Box>

      <Box
        sx={{
          ...inputGridStyles,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr 1fr"
          },
          pt: "32px"
        }}
      >
        <InputField
          name="businessLegalName"
          label={t("business_legal_name")}
          value={businessLegalName}
          placeholder={t("business_legal_name")}
          disabled
        />

        <InputField
          name="businessLocation"
          label={t("business_location")}
          value={businessLocation}
          placeholder={t("business_location")}
          disabled
        />

        <InputField
          name="businessType"
          label={t("business_type")}
          value={t("business_types." + businessType)}
          placeholder={t("business_type")}
          disabled
        />

        <InputField
          name="businessNumber"
          label={businessNumberLabel}
          value={businessNumber}
          placeholder={businessNumberLabel}
          disabled
        />
      </Box>
    </Card>
  );
};

export default BusinessProfile;
